module.exports = __webpack_public_path__ + "3b483aa2cf48312065861afa70a9ee9f.woff2";